import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import {
  detailToggleIcon,
  detailToggleIconOpen,
  showAlertDetailLink
} from '~/components/Scopes/Actions/Actions.css'

type DetailToggleProps = {
  isOpen: boolean
  onToggle: () => void
}

export const DetailToggle = ({ isOpen, onToggle }: DetailToggleProps) => (
  <div className={showAlertDetailLink} onClick={onToggle}>
    <FontAwesomeIcon
      icon={faChevronDown}
      className={clsx(detailToggleIcon, isOpen && detailToggleIconOpen)}
    />
    {isOpen ? 'Masquer' : 'Voir'} le détail
  </div>
)
